import { faMegaphone } from "@fortawesome/pro-regular-svg-icons";

import { AutoComplete, AutoCompleteItem } from "@/components/AutoComplete/AutoComplete";
import { renderListMeta } from "@/utils/listMeta";

import { List } from "../../schema/list";

interface TrackerDestinationPickerProps {
	/** The trackers and job-change lists on offer (`useTrackerDestinationLists`). */
	lists: List[];
	isLoading: boolean;
	isFetching: boolean;
	selectedTracker?: AutoCompleteItem | null;
	onSearch: (value: string) => void;
	onSelect: (value?: AutoCompleteItem) => void;
	/** Why Add has nothing to send, shown under the picker (`useTrackerAddHint`). */
	hint?: string | null;
}

/**
 * The tracker picker of the "Add to Tracker" dialogs: the Messages footer's (`useBulkAssign`) and
 * the list table's. One copy, so both offer the same destinations the same way (PREC-4497).
 */
export const TrackerDestinationPicker = ({
	lists,
	isLoading,
	isFetching,
	selectedTracker,
	onSearch,
	onSelect,
	hint,
}: TrackerDestinationPickerProps) => (
	<div className="mb-4">
		<div className="flex flex-row items-center">
			{!isLoading && (
				<AutoComplete
					data={lists.map(
						(list): AutoCompleteItem => ({
							id: list.id,
							title: list.name,
							rightContent: renderListMeta(list),
						})
					)}
					handleSearch={onSearch}
					handleSelect={onSelect}
					icon={faMegaphone}
					isLoading={isLoading || isFetching}
					label={"Custom Signal Tracker or Job Change List"}
					placeholder={"Search for a Custom Signal Tracker or Job Change list"}
					selectedItem={selectedTracker?.title || ""}
				/>
			)}
		</div>
		{hint && (
			<p className="mt-2 text-sm text-red-600" role="alert">
				{hint}
			</p>
		)}
	</div>
);
